import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BondDiceStage from "../components/bond-dice/BondDiceStage";
import BondDiceSidePanel from "../components/bond-dice/BondDiceSidePanel";
import BondPlayGameTypeRail from "../components/bond-play/BondPlayGameTypeRail";
import { BOND_PLAY_BLUE_THEME } from "../utils/bondPlayGameTypes";
import BondPlayStageHelpButton from "../components/bond-play/BondPlayStageHelpButton";
import BondDiceInfoModal from "../components/bond-play/BondDiceInfoModal";
import BondGameCelebrationModal from "../components/bond-coin/BondGameCelebrationModal";
import { initBondDiceSocket } from "../redux/bondDiceSocket";
import { fetchBondDiceConstants, fetchBondDiceLanding, selectBondDiceConstants } from "../redux/bondDiceSlice";
import { selectAppIsAuthenticated, selectAppUser } from "../redux/appAuthSlice";
import useBondGameNotify from "../hooks/useBondGameNotify";
import "../bond-play.css";
import "../bond-draw.css";
import "../bond-coin.css";
import "../bond-dice.css";
import "../bond-game-celebration.css";

const BondDice = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectAppIsAuthenticated);
  const user = useSelector(selectAppUser);
  const userCoin = Number(user?.COIN || 0);
  const constants = useSelector(selectBondDiceConstants);
  const [diceInfoOpen, setDiceInfoOpen] = useState(false);

  const { toast, celebration, notify, clearToast, clearCelebration } = useBondGameNotify();

  useEffect(() => {
    initBondDiceSocket(dispatch);
    dispatch(fetchBondDiceConstants());
    if (isAuthenticated) dispatch(fetchBondDiceLanding());
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    if (!toast) return undefined;
    const id = window.setTimeout(clearToast, 3200);
    return () => window.clearTimeout(id);
  }, [toast, clearToast]);

  return (
    <div className="bdice-page" style={BOND_PLAY_BLUE_THEME}>
      <div className="bdice-bg-glow" aria-hidden />

      <div className="bdice-layout">
        <BondPlayGameTypeRail activeGameId="bond-dice" />

        <main className="bplay-wheel-stage bdice-stage-shell">
          <BondPlayStageHelpButton
            helpLabel="How Bond Dice works"
            onOpenInfo={() => setDiceInfoOpen(true)}
          />
          <BondDiceStage
            isAuthenticated={isAuthenticated}
            userCoin={userCoin}
            onSignIn={() => navigate("/app/login")}
            onNotify={notify}
          />
        </main>

        <BondDiceSidePanel userCoin={userCoin} onNotify={notify} />
      </div>

      {toast ? <div className="bplay-toast">{toast}</div> : null}

      <BondGameCelebrationModal
        open={!!celebration}
        {...celebration}
        onClose={clearCelebration}
      />

      <BondDiceInfoModal
        open={diceInfoOpen}
        onClose={() => setDiceInfoOpen(false)}
        constants={constants}
      />
    </div>
  );
};

export default BondDice;
